import { mergePlain } from 'util/merge'
import { CLOSED } from '../constants'
import { doUpdateState } from './doUpdateState'

export const doClose = (ticketId, options = {}) => dispatch => {
  return dispatch(
    doUpdateState(
      ticketId,
      CLOSED,
      mergePlain(
        {
          moduleOptions: {
            snackbar: {
              enabled: true,
              success: {
                enabled: true,
                message: `${app.t('Ticket')} closed`,
              },
              failed: {
                enabled: true,
                message: `Oops, we couldn't close your ${app.t('ticket')}.`,
              },
            },
          },
          meta: {
            mergeEntities: true,
          },
        },
        options
      )
    )
  )
}
